import { MatrixClient } from 'matrix-js-sdk';
import { useEffect, useState } from 'react';
import { BpMatrixClient } from '../../utils/matrixClient';

// this client is used for functions that are outside of urql context
// if this is not the case for you function use useMatrixClient instead
export const useSimpleMatrixClient = () => {
  const [client, setClient] = useState<MatrixClient | null>(null);

  useEffect(() => {
    let active = true; // To prevent setting state on unmounted component

    BpMatrixClient.instance().then((fetchedClient) => {
      if (active && fetchedClient) {
        setClient(fetchedClient);
      }
    });

    return () => {
      active = false; // Prevent setting state if component unmounts before promise resolves
    };
  }, []);
  return client;
};
